








import { Component, Vue, Prop } from "vue-property-decorator";
import Common from "../components/common.vue";
import Ky from "../components/ky.vue";
import Zhp from "../components/zhp.vue";
import Wf from "../components/wf.vue";
@Component({
  components: {
    Common,
    Ky,
    Zhp,
    Wf,
  },
})
export default class Name extends Vue {
  private get configuration() {
    return this.$store.state.configuration;
  }
}
